export class RestoreKeyspacesTableRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "KeyspacesTableRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreKeyspacesTableRequest.attributeTypeMap;
    }
    constructor() {
    }
}
